import { observer, inject } from "mobx-react";
import { useState, useEffect } from "react";
import LoadingContainer from "../layouts/LoadingContainer";
import { Outlet } from "react-router-dom";
import Header from "../layouts/Header";
import SideBar from "../layouts/SideBar";
import { useTranslation } from "react-i18next";

const Admin = ({ userStore, tenantsStore }) => {
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [title, setTitle] = useState(t("menu:admin"));

  useEffect(() => {
    const updatefetchProjects = async () => {
      setLoading(true);
      tenantsStore.setError("");

      const data = {
        MAINCUST: userStore.userDetails.MAINCUST,
        CUST: userStore.userDetails.CUST,
        MAINENV: userStore.userDetails.MAINENV,
        CUSTNAME: userStore.userDetails.CUSTNAME,
        USERNAME: userStore.userDetails.USERNAME,
      };
      await tenantsStore.updateCustomerSites(data);

      await tenantsStore.updateTenants(data);

      setLoading(false);
    };
    updatefetchProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <LoadingContainer isLoading={isLoading}>
        <SideBar
          logo={userStore.userDetails.LOGO}
          setTitle={setTitle}
          admin={true}
        >
          <Header
            name={userStore.userDetails.NAME}
            title={title}
            admin={true}
          />
          <Outlet />
        </SideBar>
      </LoadingContainer>
    </>
  );
};

export default inject("userStore", "tenantsStore")(observer(Admin));
